<template>
  <div class="main">
    <div class="info-area">
      <p class="title">이용권 구매</p>
      <p class="small-line1">
        스마트폰의 카메라로 QR코드를 촬영하면<br />이용권을 구매할 수 있습니다
      </p>
      <vue-qrcode class="qr" :value="qrValue" />
      <div>
        <button
          :class="{ focused: focusIndex === 0 }"
          @click="backKeyProc"
          ref="button"
        >
          나가기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
import * as deviceApi from '../api/smartTv.js'

export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 0,
    };
  },

  components: {
    VueQrcode,
  },

  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    qrValue() {
      return (
        this.$store.getters.lambdaInfo.web +
        "/stv/intro?type=" +
        deviceApi.getOsType()
      );
    },
  },
  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },

  methods: {
    enterKeyProc(keyInput) {
      this.$router.replace({
        name: "login",
        params: {
          t: new Date().getTime(),
        },
      });
    },
    backKeyProc(keyInput) {
      this.$router.push({
        name: "login",
        params: {
          t: new Date().getTime(),
        },
      });
    },
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
}
.info-area {
  position: absolute;
  left: 96px;
  top: 198px;
}
.title {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin-bottom: 40px;
}
.small-line1 {
  font-size: 28px;
  line-height: 1.29;
  color: #888888;
  margin-bottom: 40px;
}
.qr {
  width: 240px;
  height: 240px;
  margin-bottom: 24px;
}
button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 72px;
  margin-bottom: 17px;
  margin-right: 24px;
  border: none;
}
button.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width:0px) and (max-width:1280px){
  .main {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }
  .info-area {
    position: absolute;
    left: 80px;
    top: 86px;
  }
  .title {
    font-size: 40px;
    line-height: 1;
    color: #ffffff;
    margin-bottom: 16px;
    font-weight: bold;
  }
  .small-line1 {
    font-size: 20px;
    line-height: 1.5;
    color: #888888;
    margin-bottom: 48px;
  }
  .qr {
    width: 160px;
    height: 160px;
    margin-bottom: 173px;
  }
  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    color: #ffffff;
    margin: 0;
    border: none;
  }
  button.focused {
    border: solid 3px #eeeeee;
  } 
}
</style>